import { createContext, Context } from 'react'

import { AuthContextValue } from '@auth/auth.types'

export const AuthContext: Context<AuthContextValue> = createContext({
  isLoading: true,
  isAuthorised: false,
  currentUser: null,
} as AuthContextValue)
